import { createContext, useContext, useMemo, useState } from "react";

/**
 * The DE/EN sibling path for whatever page is currently mounted, so the
 * header's language switcher can jump to the real equivalent instead of
 * naively swapping the /de//en prefix — that breaks on every route where
 * the two languages use different slugs (legal pages, About/Support
 * subpages, LARP articles like /was-ist-larp vs /what-is-larp).
 *
 * SEOHead registers this on every page (it already receives path/altPath/
 * hasTranslation for hreflang tags — same data, no separate wiring needed
 * per page).
 */
const AltPathContext = createContext({ dePath: null, enPath: null, hasTranslation: true, setAltPaths: () => {} });

export function AltPathProvider({ children }) {
  const [state, setState] = useState({ dePath: null, enPath: null, hasTranslation: true });
  const value = useMemo(() => ({ ...state, setAltPaths: setState }), [state]);
  return <AltPathContext.Provider value={value}>{children}</AltPathContext.Provider>;
}

export function useAltPaths() {
  const { dePath, enPath, hasTranslation } = useContext(AltPathContext);
  return { dePath, enPath, hasTranslation };
}

export function useSetAltPaths() {
  return useContext(AltPathContext).setAltPaths;
}
